// frontend/src/screens/ProjectScreenV2.jsx
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import { financingCode } from '../utils/financing';


import {
  useAddProjectImageMutation,
  useCreateUpdateProject2Mutation,
  useDeleteProjectMutation,
  useGetProjectById2Query,
  usePutCommentsMutation,
  useUploadProjectImageMutation,
  useAddProjectDocumentMutation
} from '../slices/projectsApiSlice';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Switch,
} from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useSelector } from 'react-redux';
import Alerton from '../components/Alerton';
import { useUpdateLinkOfStageAndProjectMutation } from '../slices/pslinkApiSlice';
import ToolChip from '../components/ToolChip';
import ProjectSpecifications from '../components/ProjectSpecifications';
import StageSwitcher from '../components/project/StageSwitcher';
import StagePaidStatus from '../components/project/StagePaidStatus';
import StageTitle from '../components/project/StageTitle';
import ProjectHistory from '../components/ProjectHistory';
import ScreenContainer from '../components/ScreenContainer';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ProjectFilesManager from '../components/ProjectFilesManager';
import DocumentViewer from '../components/DocumentViewer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';


export  function ProjectScreenV2_() {

  return (
    <div>
      <h1>Project Screen V2</h1>
      {/* Your component content goes here */}
    </div>
  );
}

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export  default function ProjectScreenV2() {
  const { id, section } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // или деструктурировать
  const { backUrl, backHash } = location.state || {};
  const { userInfo, permissions } = useSelector((state) => state.auth);
  const canReadNews = userInfo?.isAdmin || !!permissions?.news?.read;
  const { theme } = useSelector((state) => state.mode);
  //Slices
  const [editMode, setEditMode] = useState(false);
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  // const [userRoles, setUserRoles] = useState([]);
  const [color1value, setColor1value] = useState('');
  const [color2value, setColor2value] = useState('');
  const [color3value, setColor3value] = useState('');
  const [color4value, setColor4value] = useState('');
  const [noteValue, setNoteValue] = useState('');
  //states
  const [selectedStage, setSelectedStage] = useState();
  const [alertMessage, setAlertMessage] = useState('');
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [switchProgress, setSwitchProgress] = useState('');
  // const [readOnly, setReadOnly] = useState(false);

  const stageManager = userInfo?.isAdmin || !!permissions?.crm?.manageStages;
  const stageSetter = userInfo?.isAdmin || !!permissions?.crm?.setStages;
  const stageResetter = userInfo?.isAdmin || !!permissions?.crm?.resetStages;
  const commentator = userInfo?.isAdmin || !!permissions?.crm?.writeComments;
  const expandeOnStart =
    permissions?.crm?.stagesOnStart === true ? false : true;
  const canManageProjectVisibility =
    userInfo?.isAdmin || !!permissions?.crm?.changeProjectVisibility;
  const canCreateUpdateProjects =
    userInfo?.isAdmin || !!permissions?.crm?.createUpdateProjects;
  const canDeleteProjects =
    userInfo?.isAdmin || !!permissions?.crm?.deleteProjects;

  const [expanded, setExpanded] = useState(expandeOnStart);

  const [uploadProjectImage] = useUploadProjectImageMutation();
  const [updateLinkOfStageAndProject] =
    useUpdateLinkOfStageAndProjectMutation();
  const [addProjectImage] = useAddProjectImageMutation();
  const [addProjectDocument] = useAddProjectDocumentMutation();
  const [createUpdateProject] = useCreateUpdateProject2Mutation();
  const [deleteProject] = useDeleteProjectMutation();
  const [putComments] = usePutCommentsMutation();
  // const [onlyStages, setOnlyStages] = useState(false);

  const { data, refetch, isLoading, isError, error } =
    useGetProjectById2Query(id);
  // console.log('ProjectScreenV2 data', data);
  // console.log('ProjectScreenV2 permissions', permissions);

  useEffect(() => {
    if (data) {
      // if ('readOnly' in data) {
      //   setReadOnly(data.readOnly);
      // }
      setColor1value(data?.project?.color1 || '');
      setColor2value(data?.project?.color2 || '');
      setColor3value(data?.project?.color3 || '');
      setColor4value(data?.project?.color4 || '');
      setNoteValue(data?.project?.note || '');
      // if (Array.isArray(data?.userRoles) && data?.userRoles.length > 0) {
      //   setUserRoles(data.userRoles);
      // }
    }
  }, [data]);

  const handleSaveComments = () => {
    const saveData = {};
    if (data?.project?.color1 !== color1value) {
      saveData.color1 = color1value;
    }
    if (data?.project?.color2 !== color2value) {
      saveData.color2 = color2value;
    }
    if (data?.project?.color3 !== color3value) {
      saveData.color3 = color3value;
    }
    if (data?.project?.color4 !== color4value) {
      saveData.color4 = color4value;
    }
    if (data?.project?.note !== noteValue) {
      saveData.note = noteValue;
    }
    if (Object.keys(saveData).length > 0) {
      saveComments(saveData);
    }
    setEditMode(false);
  };

  const handleCancelEdit = (data) => {
    setEditMode(false);
  };

  const handleCloseUploadDialog = () => {
    setOpenUploadDialog(false);
  };

  const handleCloseMessage = () => {
    setAlertMessage('');
  };

  const handleChangeVisible = async (relevationId, checked) => {
    //управление видимостью этапов
    if (!stageManager) return;

    setSwitchProgress(relevationId);
    try {
      await updateLinkOfStageAndProject({
        linkId: relevationId,
        visible: checked,
      }).unwrap();
      setSwitchProgress('');
      refetch();
    } catch (error) {
      console.log(error);
      setAlertMessage(
        error?.data?.message || error?.error || error?.message || error,
      );
    }
  };

  const handleSwitchTurn = async (relevationId, state) => {
    // if (!userRoles.includes('CHANGE_STAGE_STATUS')) {
    //   return;
    // }
    // const nextState = state === '' ? 'start' : state === 'start' ? 'done' : '';
    // if (nextState === '' && !userRoles.includes('RESET_STAGE_STATUS')) {
    //   return;
    // }
    if (!(stageResetter || stageSetter)) return;

    setSwitchProgress(relevationId);
    try {
      await updateLinkOfStageAndProject({
        linkId: relevationId,
        state: 'stateChanged',
      }).unwrap();
      setSwitchProgress('');
      refetch();
    } catch (error) {
      console.log(error);
      setAlertMessage(
        error?.data?.message || error?.error || error?.message || error,
      );
    }
  };

  const handleExpandClick = () => {
    // if (onlyStages) {
    //   setExpanded(false);
    // } else {
    setExpanded(!expanded);
    // }
  };

  const goInvisible = async (visible) => {
    //console.log('Установим', visible);
    if (!canManageProjectVisibility) return;

    if (
      window.confirm(
        `Вы уверены что хотите сделать ${
          process.env.ENTITY === 'project' ? 'проект' : 'объект'
        } ${!visible ? 'невидимым' : 'видимым'} ?`,
      )
    ) {
      try {
        await createUpdateProject({
          _id: id,
          visible: visible,
        }).unwrap();
        refetch();
      } catch (error) {
        console.log(error);
        setAlertMessage(
          error?.data?.message || error?.error || error?.massage || error,
        );
      }
    }
  };

  const goToImagesList = () => {
    navigate(`/crm/${section}/images/${id}`);
    // navigate(`/crm/${section}/projects/images/${id}`);
  };

  const goDelete = async () => {
    if (
      window.confirm(
        `Вы уверены что хотите удалить ${
          process.env.ENTITY === 'project' ? 'проект' : 'объект'
        } ?`,
      )
    ) {
      try {
        await deleteProject({ id }).unwrap();
        // navigate(-1);
        refetch();
      } catch (error) {
        setAlertMessage(
          error?.data?.message || error?.error || error?.massage || error,
        );
      }
    }
  };

  const goBack = () => {
    if (backUrl) {
      let url = backUrl;
      if (backHash) {
        url = backUrl + '#' + backHash;
      }
      navigate(url);
    } else {
      navigate(`/crm/${section}/${id ? `#${id}` : ''}`);
    }
    // navigate(`/projects/v2/#${id ? id : ''}`);
  };

  const goEdit = () => {
    if (!canCreateUpdateProjects) return;

    navigate(`/crm/${section}/edit/${id}`);
    // navigate(`/projects/v2/edit/${id}`);
  };

  const saveComments = async (data) => {
    try {
      await putComments({
        ...data,
        _id: id,
      }).unwrap();
      refetch();
    } catch (error) {
      console.log(error);
      setAlertMessage(
        error?.data?.message || error?.error || error?.massage || error,
      );
    }
  };

  const uploadFileHandler = async (e) => {
    // if (readOnly) {
    //   return;
    // }
    setOpenUploadDialog(false);
    try {
      const formData = new FormData();
      formData.append('image', e.target.files[0]);

      const res = await uploadProjectImage(formData).unwrap(); //unwrap because it does return a promise and we want to extract that
      if (res?.image) {
        await addProjectImage({
          projectId: id,
          stageId: selectedStage,
          image: res.image,
        }).unwrap();
        refetch();
      }
    } catch (error) {
      setAlertMessage(
        error?.data?.message || error?.error || error?.message || error,
      );
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    );
  } else if (isError) {
    return (
      <Box sx={{ display: 'flex' }}>
        <Alert severity='warning'>{error?.data?.message || error.error}</Alert>
      </Box>
    );
  }

  const project = data?.project;
  const escrowDocumentsSubmitted =
    project?.isEscrowDisclosureDocumentsSubmitted === true || project?.isEscrowDisclosed === true;
  const escrowStatus = project?.isEscrowDisclosed === true
    ? { text: 'Счёт раскрыт', color: 'success.main' }
    : escrowDocumentsSubmitted
      ? { text: 'Документы на раскрытие поданы', color: 'warning.main' }
      : { text: 'Документы на раскрытие не поданы', color: 'text.disabled' };
  if ((Array.isArray(project) && project.length === 0) || !project?._id) {
    return (
      <Box sx={{ display: 'flex' }}>
        <Alert severity='warning'>Проект не найден или у вас нет доступа</Alert>
      </Box>
    );
  }
  const visible = project?.visible;
  const stages = project?.stages;
  // console.log(stages);
  //const currentStage = stages.find((item) => item.state !== 'done');
  const phones = [];
  if (project?.phones?.length > 0) {
    if (project?.phones.includes(',')) {
      phones.push(...project.phones.split(','));
    } else if (project?.phones.includes(';')) {
      phones.push(...project.phones.split(';'));
    } else if (project?.phones.includes('|')) {
      phones.push(...project.phones.split('|'));
    } else {
      phones.push(project.phones);
    }
  }

  // console.log(stages);

  const InfoRow = ({
    title,
    value,
    mb = 0,
    alignItems = 'left',
    postfix,
    component,
    fullWidth,
  }) => {
    if (title) {
      return (
        <Grid
          item
          xs={12}
          spacing={1}
          container
          sx={{ pb: 0, mb }}
          alignItems={alignItems}
        >
          <Grid item xs={fullWidth ? 12 : 4}>
            <strong>{title}:</strong>
          </Grid>
          {component ? (
            component
          ) : (
            <Grid item xs={fullWidth ? 12 : 8}>
              {`${value} ${postfix || ''}`}
            </Grid>
          )}
        </Grid>
      );
    }

    return (
      <Grid item xs={12} spacing={1} container sx={{ pb: 0, mb }}>
        <Grid item xs={12}>
          {value}
        </Grid>
      </Grid>
    );
  };

  const buttons = [];
  if (canCreateUpdateProjects) {
    buttons.push({
      value: 'right',
      type: 'ToggleButton',
      onClick: goEdit,
      icon: <EditNoteIcon />,
      position: 'left',
    });
    buttons.push({
      value: 'right',
      type: 'ToggleButton',
      onClick: () => setShowDocumentsModal(!showDocumentsModal),
      // Динамический цвет иконки:
      icon: <AttachFileIcon color={showDocumentsModal ? 'success' : 'inherit'} />, 
      position: 'left',
    });
  }
  if (userInfo?.isAdmin && !userInfo?.readOnly) {
    buttons.push({
      value: 'right', type: 'ToggleButton',
      ariaLabel: 'Исправить воронку и исторические этапы',
      onClick: () => navigate(`/crm/${section}/${id}/funnel-correction`),
      icon: <SwapHorizIcon />, position: 'left',
    });
  }
  // if (canManageProjectVisibility) {
  //   buttons.push({
  //     value: 'right',
  //     type: 'ToggleButton',
  //     onClick: () => {
  //       goInvisible(!project?.visible);
  //     },
  //     icon: project?.visible ? (
  //       <VisibilityIcon />
  //     ) : (
  //       <VisibilityOffIcon sx={{ color: '#8d6e63' }} />
  //     ),
  //     position: 'left',
  //   });
  // }

  if (buttons.length === 0) {
    buttons.push({
      type: 'Divider',
      flexItem: true,
      orientation: 'vertical',
      sx: { mx: 0.5, my: 1 },
      position: 'left',
    });
  }
  if (canDeleteProjects) {
    buttons.push({
      value: 'right',
      type: 'ToggleButton',
      onClick: goDelete,
      icon: project?.visible ? (
        <DeleteForeverIcon />
      ) : (
        <RestoreFromTrashIcon color='warning' />
      ),
      position: 'left',
    });
  }
  buttons.push({
    value: 'right',
    type: 'ToggleButton',
    onClick: goBack,
    icon: <CloseIcon color={editMode ? 'success' : 'primary'} />,
    position: 'right',
  });

  // console.log('buttons', buttons);

  let projectStages = [];

  if (stageManager) {
    projectStages = stages || [];
  } else {
    projectStages = stages?.filter((stage) => stage?.visible) || [];
  }

  return (
    <>
      <ScreenContainer toggleButtons={buttons}>
        <Card
          sx={{
            maxWidth: 720,
            bgcolor: !visible && (theme === 'dark' ? '#3e2723' : '#ffebee'),
          }}
        >
          <CardContent sx={{ pb: 0, pt: 2, pr: 0 }} position='sticky'>
            <Grid
              item
              xs={12}
              spacing={1}
              container
              sx={{ pb: 0, mb: 1 }}
              alignItems='center'
            >
              <Grid item xs={10}>
                <h2 style={{ padding: '0px', margin: '0px' }}>
                  {project.title}
                </h2>
              </Grid>
              <Grid item xs={2}>
                <ToolChip onClick={handleExpandClick}>
                  <ExpandMore
                    expand={expanded}
                    aria-expanded={expanded}
                    aria-label='show more'
                  >
                    <ExpandMoreIcon />
                  </ExpandMore>
                </ToolChip>
              </Grid>
            </Grid>
          </CardContent>

          <Collapse in={expanded} timeout='auto' unmountOnExit>
            {/* {Array.isArray(project?.images) && (
              <ImageCarouselV2 project={project} stages={stages} />
            )} */}
            <CardContent sx={{ pt: 0 }}>
              <Grid container spacing={1} sx={{ mt: 1 }}>
                {project?.description && (
                  <Grid
                    item
                    xs={12}
                    spacing={1}
                    container
                    sx={{ pb: 0, mb: 0 }}
                  >
                    <Grid item xs={12}>
                      {project.description}
                    </Grid>
                  </Grid>
                )}
                {/* {project?.region && (
                  <InfoRow title='Филиал' value={project.region?.title} />
                )} */}
                {/* ВЫЗОВ КОМПОНЕНТА СПЕЦИФИКАЦИЙ*/}
                {/* <Grid size={{ xs: 12 }} sx={{ mt: 2, mb: 2 }}>

                        <ProjectSpecifications
                          project={project}
                          canEdit={canCreateUpdateProjects} 
                          uploadMutation={uploadProjectImage} 
                          updateProjectMutation={addProjectDocument} 
                        />
    
                </Grid> */}
{Array.isArray(project?.specificationFiles) && project.specificationFiles.length > 0 && (
  <Grid 
    item 
    xs={12} 
    spacing={1} 
    container 
    sx={{ pb: 0, mb: 0, alignItems: 'flex-start' }}
  >
    <Grid item xs={4}>
      <strong>Документы:</strong>
    </Grid>
    <Grid item xs={8}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        {project.specificationFiles.map((file, index) => (
          <Button
            key={file?._id || index}
            onClick={() => setSelectedFile(file)}
            disableRipple // Отключаем эффект "волны" при клике, чтобы ощущалось как обычная ссылка
            sx={{ 
              justifyContent: 'flex-start', 
              textAlign: 'left', 
              textTransform: 'none',
              p: 0, // Убираем все отступы (заменяем px: 0 на p: 0)
              mb: 0.5, // Небольшой отступ снизу между ссылками, если их несколько
              minWidth: 'auto',
              fontWeight: 400,
              fontSize: '1rem', // Стандартный размер текста (или можно использовать 'inherit')
              lineHeight: 1.5,
              // color: 'primary.main',
              textDecoration: file?.visible ? 'none' : 'line-through',
              color: file?.visible ? 'primary.main' : 'text.disabled',
              '&:hover': {
                backgroundColor: 'transparent', // Убираем серый фон при наведении
                textDecoration: 'underline'     // Добавляем подчеркивание как у классических ссылок
              }
            }}
          >
            {file.name}
          </Button>
        ))}
      </Box>
    </Grid>
  </Grid>
)}


                {project?.type && (
                  <InfoRow title='Тип' value={project.type?.title} />
                )}
                {project?.manager && (
                  <InfoRow title='Менеджер' value={project.manager?.name} />
                )}
                {project?.leadSource && (
                  <InfoRow
                    title='Источник'
                    value={project.leadSource?.title}
                    postfix={project.referrer}
                  />
                )}
                {project?.kadastr && (
                  <InfoRow title='Кадастр.№' value={project.kadastr} />
                )}
                {(project?.buildingProject || project?.projectName) && (
                  <Grid
                    item
                    xs={12}
                    spacing={1}
                    container
                    sx={{ pb: 0, mb: 0 }}
                  >
                    <Grid
                      item
                      xs={4}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <strong>Проекты домов:</strong>
                    </Grid>
                    <Grid item xs={8}>
                      {project?.buildingProject && (
                        <Grid item>
                          <strong>{project.buildingProject?.title}</strong>
                        </Grid>
                      )}
                      {project?.projectName && (
                        <Grid item>
                          <strong>{project.projectName}</strong>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                )}
                {project?.period && (
                  <InfoRow title='Срок' value={project.period} />
                )}
               
                <Grid item xs={12} spacing={1} container sx={{ pb: 0, mb: 0 }}>
                  <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
                    <strong>Финансирование:</strong>
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: { xs: 'flex-end', sm: 'flex-start' },
                    }}
                  >
                    <Typography variant='body2'>{project?.financingType?.title || 'Не определились'}</Typography>
                  </Grid>
                </Grid>
                {financingCode(project?.financingType) === 'mortgage' && (
                  <Grid item xs={12} spacing={1} container sx={{ pb: 0, mb: 0 }}>
                    <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
                      <strong>Эскроу:</strong>
                    </Grid>
                    <Grid item xs={8} sx={{ display: 'flex', justifyContent: { xs: 'flex-end', sm: 'flex-start' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', color: escrowStatus.color, ml: { sm: -0.5 } }}>
                        {escrowDocumentsSubmitted ? (
                          <CheckCircleIcon fontSize='small' sx={{ mr: 0.5 }} />
                        ) : (
                          <RemoveCircleOutlineIcon fontSize='small' sx={{ mr: 0.5 }} />
                        )}
                        <Typography variant='body2' sx={{ fontWeight: escrowDocumentsSubmitted ? 500 : 400 }}>
                          {escrowStatus.text}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )}



                {project?.paidInitialPayment &&(
                <Grid item xs={12} spacing={1} container sx={{ pb: 0, mb: 0 }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: 'flex', alignItems: 'center' }}
                  >
                    <strong>Первоначальный взнос:</strong>
                  </Grid>
                  <Grid  item xs={8} sx={{ display: 'flex', justifyContent: { xs: 'flex-end', sm: 'flex-start' } }}>
                    <Switch
                      onChange={() => {}}
                      checked={project?.paidInitialPayment || false}
                      color='error'
                      // disabled
                    />
                  </Grid>
                  {!!project?.initialPaymentSource &&(
                    <InfoRow
                      title='Источник взноса'
                      value={project.initialPaymentSource}
                    />
                  )}
                </Grid>
                )}
                {project?.phones && (
                  <Grid
                    item
                    xs={12}
                    spacing={1}
                    container
                    sx={{ pb: 0, mb: 0 }}
                  >
                    <Grid item xs={4}>
                      <strong>
                        {process.env.ENTITY === 'project'
                          ? 'Контакт'
                          : 'Заказчик:'}
                      </strong>
                    </Grid>
                    <Grid item xs={8}>
                      {phones.map((phone, index) => (
                        <Box
                          key={index}
                          sx={{
                            mb:
                              phones.length > 1 && index < phones.length - 1
                                ? 1
                                : 0,
                          }}
                        >
                          <Callto key={phone} phone={phone}>
                            <Chip
                              icon={<LocalPhoneIcon />}
                              label={phone}
                              variant='outlined'
                            />
                          </Callto>
                          <br />
                        </Box>
                      ))}
                    </Grid>
                  </Grid>
                )}
                {commentator && (
                  <Grid
                    item
                    xs={12}
                    spacing={1}
                    container
                    sx={{
                      pb: 0,
                      mb: 0,
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    {editMode ? (
                      <ButtonGroup variant='text' aria-label='button group'>
                        <Button onClick={() => handleSaveComments()}>
                          Сохранить
                        </Button>
                        <Button onClick={() => handleCancelEdit()}>
                          Отмена
                        </Button>
                      </ButtonGroup>
                    ) : (
                      <Switch
                        onChange={() => setEditMode(!editMode)}
                        checked={editMode}
                      />
                    )}
                  </Grid>
                )}

                {editMode && commentator ? (
                  <Box
                    component='form'
                    sx={{ width: '100%', '& .MuiTextField-root': { m: 1 } }}
                    noValidate
                    autoComplete='off'
                  >
                    <div>
                      <TextField
                        fullWidth
                        size='small'
                        id='outlined-multiline-krovlya'
                        label='Кровля'
                        multiline
                        rows={2}
                        value={color1value}
                        onChange={(event) => setColor1value(event.target.value)}
                      />
                    </div>
                    <div>
                      <TextField
                        fullWidth
                        size='small'
                        id='outlined-multiline-fasad'
                        label='Фасад'
                        multiline
                        rows={2}
                        value={color2value}
                        onChange={(event) => setColor2value(event.target.value)}
                      />
                    </div>
                    <div>
                      <TextField
                        fullWidth
                        size='small'
                        id='outlined-multiline-karniz'
                        label='Карниз'
                        multiline
                        rows={2}
                        value={color3value}
                        onChange={(event) => setColor3value(event.target.value)}
                      />
                    </div>
                    <div>
                      <TextField
                        fullWidth
                        size='small'
                        id='outlined-multiline-okna'
                        label='Окна'
                        multiline
                        rows={2}
                        value={color4value}
                        onChange={(event) => setColor4value(event.target.value)}
                      />
                    </div>
                    <div>
                      <TextField
                        fullWidth
                        size='small'
                        id='outlined-multiline-okna'
                        label='Общая заметка по клиенту'
                        multiline
                        rows={2}
                        value={noteValue}
                        onChange={(event) => setNoteValue(event.target.value)}
                      />
                    </div>
                  </Box>
                ) : (
                  <>
                    {project?.color1 && (
                      <InfoRow title='Кровля' value={project?.color1} />
                    )}
                    {project?.color2 && (
                      <InfoRow title='Фасад' value={project?.color2} />
                    )}
                    {project?.color3 && (
                      <InfoRow title='Карниз' value={project?.color3} />
                    )}
                    {project?.color4 && (
                      <InfoRow title='Окна' value={project?.color4} />
                    )}
                    {project?.note && (
                      <InfoRow
                        title='Комментарий'
                        value={project?.note}
                        fullWidth
                      />
                    )}
                  </>
                )}
              </Grid>
            </CardContent>
          </Collapse>

          <Collapse in={!expanded} timeout='auto' unmountOnExit sx={{ pt: 0 }}>
            <CardContent sx={{ pt: 0 }}>
              <List sx={{ pt: 0 }}>
                {projectStages.map((item) => (
                  <span key={item._id}>
                    <ListItem dense={true} sx={{ py: 1, px: 0 }}>
                      {stageManager && (
                        <StagePaidStatus
                          item={item}
                          onCkeck={handleChangeVisible}
                        />
                      )}
                      <StageTitle item={item} />
                      <StageSwitcher
                        item={item}
                        onSwitch={handleSwitchTurn}
                        resetable={stageResetter}
                        changable={stageSetter}
                      />
                    </ListItem>
                    {switchProgress === item?.linkId && <LinearProgress />}
                  </span>
                ))}
              </List>
            </CardContent>
          </Collapse>
        </Card>
        {canReadNews && (
          <ProjectHistory
            projectId={id}
            stages={stages}
            theme={theme}
            setAlertMessage={setAlertMessage}
          />
        )}
      </ScreenContainer>
      <Alerton message={alertMessage} handleCloseMessage={handleCloseMessage} />
      <Dialog
        fullScreen={true}
        open={openUploadDialog}
        onClose={handleCloseUploadDialog}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>
          {'Выберите этап к которому будет привязан загружаемый файл'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <List
                sx={{
                  width: '100%',
                  //maxWidth: 360,
                  bgcolor: 'background.paper',
                  position: 'relative',
                  overflow: 'auto',
                  //maxHeight: 300,
                  '& ul': { padding: 0 },
                }}
                subheader={<li />}
              >
                {stages
                  .filter((item) => item.visible)
                  .map((item) => (
                    <ListItem
                      sx={{
                        p: 1,
                        '& .Mui-selected': {
                          backgroundColor: `${
                            theme === 'dark' ? '#455a64' : '#b2ebf2'
                          } !important`,
                        },
                      }}
                      dense
                      key={item._id}
                      onClick={() => setSelectedStage(item._id)}
                    >
                      <ListItemButton selected={item._id === selectedStage}>
                        <ListItemText
                          primary={
                            <Typography variant='button'>
                              {item.title}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid item xs={6}>
            <Button
              component='label'
              variant='contained'
              startIcon={<CloudUploadIcon />}
              href='#file-upload'
            >
              Выбрать файл
              <VisuallyHiddenInput type='file' onChange={uploadFileHandler} />
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant='contained'
              autoFocus
              onClick={handleCloseUploadDialog}
            >
              Отмена
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <ProjectFilesManager 
        open={showDocumentsModal} 
        onClose={() => setShowDocumentsModal(false)} 
        project={project} 
        onSuccess={refetch}
      />
      {/* Модальный вьювер документов */}
      <DocumentViewer 
        open={Boolean(selectedFile)} 
        onClose={() => setSelectedFile(null)} 
        file={selectedFile} 
      />
    </>
  );
}

const Callto = ({ phone, children }) => {
  return <a href={`tel:${phone}`}>{children}</a>;
};
